export default "__VITE_ASSET__CMVHvRMK__"